import React from 'react';
import BiddingInfoItem from '../../molecules/bidding_info_item';
import { Container } from '../../molecules/bidding_info_item/styles';
import { BiddingInfoTypes } from '../../../store/modules/bidding_store/types';

interface BiddingInfoProps {
  bidding_info: BiddingInfoTypes[];
  // eslint-disable-next-line react/require-default-props
  initiallyOpen?: boolean;
  // eslint-disable-next-line react/require-default-props
  trackEvents?: boolean;
}

const BiddingInfoList = ({ bidding_info, initiallyOpen, trackEvents }: BiddingInfoProps) => {
  return (
    <Container>
      <div className="row">
        <div className="col-md-12">
          {bidding_info.length > 0 ? (
            bidding_info.map((info: BiddingInfoTypes) => (
              <BiddingInfoItem
                key={info.id}
                info={info}
                initiallyOpen={initiallyOpen}
                trackEvents={trackEvents}
              />
            ))
          ) : (
            <div className="row">
              <div className="text-center col-md-12">Nenhum item encontrado.</div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default BiddingInfoList;
